import axiosInstance from "../../api/axiosConfig";
import { GET_CLIENT_BY_SLUG } from "./ClientQuery.ts";
import logger from "../../utils/logger";

const API_GQL_URL = "/gql";
const API_URL = "/auth";

const getClientBySlug = async (clientSlug) => {
    try {
        const response = await axiosInstance.post(API_GQL_URL, {
            query: GET_CLIENT_BY_SLUG,
            variables: { slug: clientSlug }
        }, { timeout: 60000 });
        return response.data.data.getClientSlug;
    } catch (error) {
        logger.error("Error fetching client data:", error);
        throw error;
    }
};

const loginAdmin = async (username, password, clientSlug) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/login`, { username, password, clientSlug });
        return response.data;
    } catch (error) {
        logger.error("Error logging in admin:", error);
        throw error;
    }
};

const loginSuperadmin = async (username, password) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/login-superadmin`, { username, password });
        return response.data;
    } catch (error) {
        logger.error("Error logging in superadmin:", error);
        throw error;
    }
}

const getAllServiceImages = async (clientSlug) => {
    try {
        const response = await axiosInstance.get(`/clientsPublic/all-service-images/${clientSlug}`, {
            timeout: 60000
        });
        return response.data;
    } catch (error) {
        logger.error("Error fetching all service images:", error);
        throw error;
    }
};

const ClientServiceP = {
    getClientBySlug,
    loginAdmin,
    loginSuperadmin,
    getAllServiceImages,
};

export default ClientServiceP;